import { VisualDataQueryColumnCollection } from '../../VisualDataSource';
import { ColumnImpl } from './ColumnImpl';

export const ColumnCollectionImpl = VisualDataQueryColumnCollection<ColumnImpl>;